import { ff } from '@atlassian/jira-feature-flagging';
import type { ViewType } from '@atlassian/jira-ui-modifications-types';

export const GIC_VIEW_TYPE = 'GIC';
export const ISSUE_VIEW_VIEW_TYPE = 'IssueView';
export const ISSUE_TRANSITION_VIEW_TYPE = 'IssueTransition';

export const getSupportedViewTypes = (): ViewType[] => [
	GIC_VIEW_TYPE,
	ISSUE_VIEW_VIEW_TYPE,
	...(ff('ui-modifications-on-issue-transition-view_7z1g0') ? [ISSUE_TRANSITION_VIEW_TYPE] : []),
];
